import ManagerTemplate from 'components/manager/ManagerTemplate';

const ManagerPage = () => {
  return <ManagerTemplate />;
};

export default ManagerPage;
